import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import Cover from '../components/Cover';
import { getToken, getTokenLogo, getTokenSymbol } from '../constants/logos';
import vec1 from '../images/Vector.svg';
import vec2 from '../images/Vector2.svg';
import vec3 from '../images/Vector3.svg';
import vec4 from '../images/Vector4.svg';
import { WalletContext } from '../context/WalletContext';
import breakpoints from '../utils/breakpoints';
import Footer from '../components/Footer';
import ManageToken from '../components/ManageTokens/ManageToken';
import { NoPoolFound } from '../components/NoPoolFound';

const Main = styled.div`
  height: 100%;
  width: 100%;
  padding: 35px 0px;
  margin: auto;
  /* background: #d8e7fc; */

  .link {
    color: #000;
    text-decoration: none;
  }

  @media only screen and (max-width: 400px) {
    width: 100%;
  }

  .vec1 {
    position: absolute;
    top: 10%;
    left: -4%;
  }

  .vec2 {
    position: absolute;
    top: 49%;
    left: -4%;
  }

  .vec3 {
    position: absolute;
    top: 10%;
    right: -4%;
  }

  .vec4 {
    position: absolute;
    top: 49%;
    right: -4%;
  }
`;

const Create = styled.div`
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .fields {
    width: 80%;

    input {
      border: 1px solid #ecf3ff;
      border-radius: 18px;
      padding: 15px 25px;
      font-size: 16px;
      text-transform: uppercase;
      text-align: center;
      width: calc(50% - 20px);

      &:first-child {
        margin-right: 20px;
      }

      &:focus {
        box-shadow: rgb(0 0 0 / 3%) 3px 6px 10px;
      }
    }
  }
  .action {
    width: 30%;
    display: flex;
    justify-content: end;
    text-decoration: none;
  }
`;

// ***************************************


const List = styled.div`
  display: flex;
  justify-content: center;
  width: 80%;
  margin: auto;
  align-items: center;
  flex-wrap: wrap;
  /* @media only screen and ${breakpoints.device.lg} {
    display: flex;
    justify-content: center;
    align-items: center;
  } */

  li {
    list-style: none;
    z-index: 1;
    padding: 20px;
    @media only screen and (${breakpoints.device.sm}) {
    }

    @media only screen and (${breakpoints.device.md}) {
      margin: 30px 0;
    }

    @media only screen and (${breakpoints.device.lg}) {
      list-style: none;
    }

    .list-item {
      background: #fff;
      box-shadow: 0px 3.38681px 3.38681px rgba(0, 0, 0, 0.14);
      border-radius: 15.2407px;
      width: 332.75px;
      cursor: pointer;

      .brand {
        width: 100%;
        padding: 15px 52px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        z-index: 1;

        .child {
          width: 100%;
          margin-left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          width: 42.49px;
          height: 42.49px;
          margin-bottom: 10px;
        }

        .title {
          font-style: normal;
          font-weight: 700;
          font-size: 14.7387px;
          line-height: 17px;
          color: #424242;
        }
      }

      .info {
        padding: 20px 9px;
        display: flex;
        border-top: 1px solid #efefef;
        margin: 0;

        .child {
          width: 50%;
          display: flex;
          flex-direction: column;
          .inner_title {
            font-style: normal;
            font-weight: 600;
            font-size: 11.2708px;
            line-height: 14px;
            color: #828282;
          }
          .inner_value {
            font-style: normal;
            font-weight: 700;
            font-size: 15.6057px;
            line-height: 12px;
            text-align: center;
            color: #0045ff;
            margin-top: 10px;
          }
        }
      }

      .inner_action {
        font-weight: 700;
        font-size: 11.2708px;
        line-height: 12px;
        color: #828282;
        border-top: 1px solid #efefef;
        cursor: pointer;
        text-align: center;
        padding: 10px 0px;
      }

      &:hover {
        cursor: pointer;
        transform: scale(1.05);
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        transition: all 0.5s;
      }
    }
  }
`;

const listData = [
  // {
  //   poolAddress: "0x72E977128470D1d79C986fD797AD99b3AFd1d63F",
  //   tokens: ["DAI", "LINK"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  // {
  //   poolAddress: "0x25Eb791Fd851B75a1C29B58bBC25bbf42bB8bbD6",
  //   tokens: ["DAI", "USDC"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  // {
  //   poolAddress: "0xcd6b8482894401d4703425163B89bc92497c4cb3",
  //   tokens: ["LINK", "USDC"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  // {
  //   poolAddress: "0x5c643909cea9067936B2e5cda21D1d1A2287aF65",
  //   tokens: ["LINK", "UFT"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  // {
  //   poolAddress: "0x999f86a50628dC7669A4DD2f09bDa40B22BB5835",
  //   tokens: ["OMATIC", "OUNI"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  // {
  //   poolAddress: "0xB0445daDD346994e91898b34949919853f74B622",
  //   tokens: ["OUSDC", "OBNB"],
  //   supply: "$120,45,000",
  //   borrowed: "$45,000",
  // },
  {
    // poolAddress: '0x40d3b357d8E70bD4a3d1595FBf1AF209F28B7E3c',
    // 0x918fe9e1afa89620e89f9907f4c95c93801a9aa3d7f4aa07d6140cd61713e23e
    poolAddress: '0x9Be89Ab05f8730e873f195daF329a0C5Db2ECca4',
    tokens: ['USDC', 'WETH'],
    supply: '$12,045,000',
    borrowed: '$7,310,455',
  },
  {
    // poolAddress: '0xc2cb7a0D3721c8D788B01d5140CF919C2cc9B64a',
    poolAddress: '0xad9E05A861B70Ae2E18C4EC5a3B47B59E65B535E',
    tokens: ['DAI', 'WETH'],
    supply: '$1,683,215',
    borrowed: '$897,642',
  },
  {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xAc961A1F91b25ffd24b0FBB43d76d4369bAa2519',
    tokens: ['UFT', 'WETH'],
    supply: '$5,302,153',
    borrowed: '$3,817,985',
  },
  {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0x445949DDbbf05D5173e9Fc09B48e3B36A2e80e7a',
    tokens: ['UFT', 'USDC'],
    supply: '$3,123,179',
    borrowed: '$2,577,986',
  },
  {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xcC6cd2528aA214784C8AA260442606a20c9891f1',
    tokens: ['WBTC', 'WETH'],
    supply: '$6,387,157',
    borrowed: '$3,246,700',
  },
  {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xF30A7F4ABF997050241d6a6d9A5D035770AfcfFf',
    tokens: ['USDC', 'DAI'],
    supply: '$5,173,892',
    borrowed: '$2,981,366',
  },
  {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xB7D0A5D21DE1b1581799cE1EFD78C1D20F731512',
    tokens: ['WBNB', 'BUSD'],
    supply: '$5,173,892',
    borrowed: '$2,981,366',
  },
];

const PoolsList = ({ fromToken = false }) => {
  const { currentAccount, isConnected, uV2Core, connectWallet } =
    useContext(WalletContext);

  const [createPoolLoader, setCreatePoolLoader] = useState(false);
  const [token1, setToken1] = useState({});
  const [token2, setToken2] = useState({});
  const [poolData, setPoolData] = useState(listData);
  const navigate = useNavigate();

  const handleTokens = (token, selectedToken) => {
    if (selectedToken === 'token1') {
      setToken1(token);
    } else if (selectedToken === 'token2') {
      setToken2(token);
    }
  };

  const handleNavigation = (poolAddress) => {
    if (isConnected) {
      navigate(`pool/${poolAddress}`);
    } else {
      connectWallet();
    }
  };

  useEffect(() => {
    let filtredData;
    if (token1.symbol && token2.symbol) {
      filtredData = poolData.filter(
        (item) =>
          item.tokens
            .map((sy) => sy.toLowerCase())
            .includes(token1.symbol.toLowerCase()) &&
          item.tokens
            .map((sy) => sy.toLowerCase())
            .includes(token2.symbol.toLowerCase())
      );
    } else if (token1.symbol && !token2.symbol) {
      filtredData = poolData.filter((item) =>
        item.tokens
          .map((sy) => sy.toLowerCase())
          .includes(token1.symbol.toLowerCase())
      );
    } else if (!token1.symbol && token2.symbol) {
      filtredData = poolData.filter((item) =>
        item.tokens
          .map((sy) => sy.toLowerCase())
          .includes(token2.symbol.toLowerCase())
      );
    } else if (!token1.symbol && !token2.symbol) {
      filtredData = poolData;
    }
    setPoolData(filtredData);
  }, [token1, token2]);

  // useEffect(() => {
  //   if (currentNetwork !== "KOVAN") {
  //     tl.to(".modal_wrapper", 1, {
  //       x: -20,
  //       opacity: 1,
  //       ease: "Power3.easeInOut",
  //     })
  //   } else {
  //     tl.to(".modal_wrapper", 2, {
  //       x: 1000,
  //       opacity: 1,
  //       delay: 1,
  //       ease: "Power3.easeInOut",
  //     })
  //   }
  // }, [currentNetwork])

  const createPool = () => {
    setCreatePoolLoader(true);

    if (uV2Core) {
      uV2Core.methods
        .createPool(
          '0x5fB282Df60a3264c06b2Cb36c74d0Fd23D727f82',
          '0x0bc8AEE2DbecfB45E1559BD7F81905156Cf64077'
          // '0x6f14C02Fc1F78322cFd7d707aB90f18baD3B54f5'
        )
        .send({ from: currentAccount })
        .on('transactionHash', (dData) => {
          
          setCreatePoolLoader(false);
          // checkTxnStatus(dData, ".wrap");
        })
        .on('error', function (error) {
          console.log(error);

          // _rbtnLoader(".wrap", 'Approve');
        });
    }
  };

  // Error Modal should be in a seperate component and in the navbar component **
  return (
    <>
      <div>
        <Main style={fromToken ? { padding: '0px' } : {}}>
          {!fromToken && (
            <>
              {' '}
              <Cover />{' '}
            </>
          )}
          <ManageToken handleTokens={handleTokens} />
          <List>
            {poolData.length > 0 &&
              poolData.map((item) => (
                <li>
                  <div
                    onClick={() => handleNavigation(item.poolAddress)}
                    className='list-item'
                  >
                    <div className='brand'>
                      <div>
                        <div className='child'>
                          <img src={getToken(item.tokens[0])['logo']} />
                        </div>
                        <span className='title'>
                          {getTokenSymbol(item.tokens[0])}
                        </span>
                      </div>

                      <div>
                        <div className='child'>
                          <img src={getToken(item.tokens[1])['logo']} />
                        </div>
                        <span className='title'>
                          {getTokenSymbol(item.tokens[1])}
                        </span>
                      </div>
                    </div>

                    <div className='info'>
                      <div className='child'>
                        <span className='inner_title'>Total Supply</span>
                        <span className='inner_value'>{item.supply}</span>
                      </div>
                      <div className='child'>
                        <span className='inner_title'>Total Borrowed</span>
                        <span className='inner_value'>{item.borrowed}</span>
                      </div>
                    </div>
                    <div className='inner_action'>More Details</div>
                  </div>
                </li>
              ))}
          </List>
          {poolData.length == 0 && (
            <NoPoolFound
              token1={token1}
              token2={token2}
              createPool={createPool}
            />
          )}
        </Main>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default PoolsList;
